import React from 'react';
import { PropTypes } from 'prop-types';

/**
 * Link renderer for Markdown content (announcement notes, the tips page).
 *
 * Markdown has no syntax for "open in a new tab" vs "same tab", so we decide by
 * destination:
 *   - External (a full http/https URL to another site) → opens in a NEW tab,
 *     so the reader doesn't lose Doctivity.
 *   - Internal (a site-relative path like /providers/123, or a same-origin URL)
 *     → opens in the SAME tab and navigates to that page in Doctivity.
 */
const SmartMarkdownLink = ({ href = '', children }) => {
  const isExternal =
    /^https?:\/\//i.test(href) &&
    !(typeof window !== 'undefined' && href.startsWith(window.location.origin));

  if (isExternal) {
    return (
      <a href={href} target='_blank' rel='noopener noreferrer'>
        {children}
      </a>
    );
  }
  return <a href={href}>{children}</a>;
};

SmartMarkdownLink.propTypes = {
  href: PropTypes.string,
  children: PropTypes.node,
};

export { SmartMarkdownLink };
export default SmartMarkdownLink;
